import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageUserService {

  url = `${environment.apiURL}/users`;

  constructor(private http: HttpClient) {
  }

  get(id = null): Observable<any> {
    let url = this.url;
    if (id) {
      url += `?userID=${id}`;
    }
    return this.http.get(url);
  }

  delete(id): Observable<any> {
    return this.http.delete(`${this.url}?userID=${id}`);
  }
}
